$(() => {
    if (document.getElementById('client-invoice-freee-form') != null) {
        displayApproverId($('select[name="approval_flow_route_id"] option:selected').text());
        $('select[name="approval_flow_route_id"]').on('change', function() {
            displayApproverId($('select[name="approval_flow_route_id"] option:selected').text());
        });

        $('.js-freee-select').select2({
            width: '100%',
            placeholder: '選択してください',
            allowClear: true,
            language: 'ja',
            tags: true
        });

        $('.freee-submit-exec').on('click', function() {
            $('#freee_form').submit();
        });
    }

    function displayApproverId(select_name)
    {
        if (select_name == '承認者を指定') {
            $('.js-approver_id').show();
        } else {
            $('.js-approver_id').hide();
        }
    }
});
